<template>
	<div class="content-box-wrapper margin-bottom-xs-2">
		<div class="content-box-header">
			<h2 class="content-box-header__headline text-17">
				Din grupp: <span v-html="user.group_name"></span>
			</h2>
		</div>
		<div class="content-box-padding loading-spinner-wrapper">
			<LoadingSpinner v-if="!loaded.groupMeta" />
			<div v-if="loaded.groupMeta">
				<p>
					Den här gruppen har {{ numberOfGroupMembers }}. Klicka på en
					modul för att se hur medlemmar i din grupp svarat.
				</p>
				<div class="row row-slider">
					<OwnerModuleCard
						v-for="module in modules"
						:module="module"
						:key="module.name"
						class="col-9 col-sm-6 col-xl-4 margin-bottom-xs-2"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import getModules from "./../mixins/getModules.vue";
import LoadingSpinner from "./../partials/LoadingSpinner.vue";
import OwnerModuleCard from "./OwnerModuleCard.vue";

export default {
	name: "OwnerDashboard",
	props: [],
	components: { LoadingSpinner, OwnerModuleCard },
	computed: {
		numberOfGroupMembers() {
			if (this.groupMeta.users.length == 1) {
				return "1 medlem";
			} else {
				return this.groupMeta.users.length + " medlemmar";
			}
		},
		loaded() {
			return this.$store.state.loaded;
		},
		user() {
			return this.$store.state.user;
		},
		modules() {
			return this.$store.state.modules;
		},
		groupMeta() {
			return this.$store.state.groupMeta;
		}
	},
	methods: {},
	mounted() {
		this.$store.dispatch("getGroupMeta");
	}
};
</script>